import {
    ContainerDataType,
    TaskConfigType,
    TaskMode,
    TextAnnotationDataType,
    TextAnnotationsListType,
} from 'Types/Tasks.types'
import { ContainerType } from 'Types/Tasks.types'
import { IContainerStrategy } from '../ContainerStrategy'
import { cloneDeep } from 'lodash'
import { TextAnnotationTask } from 'Tasks/TextAnnotationTask/TextAnnotationTask'
import { isViewerMode } from 'Utils/task.utils'

export class TextAnnotationContainerStrategy
    implements IContainerStrategy<ContainerType.TextAnnotation, TextAnnotationDataType>
{
    containerContext?: {
        task: TextAnnotationTask
    }

    setContext(containerContext: { task: TextAnnotationTask }) {
        this.containerContext = containerContext
    }

    getEmptyDraftContainer(): ContainerDataType<
        ContainerType.TextAnnotation,
        TextAnnotationDataType
    > {
        return {
            data: {
                schema_version: 1,
                type: ContainerType.TextAnnotation,
                data: {
                    quality_check: {
                        evaluation_on_response_version_id: {},
                    },
                    response: {
                        id: crypto.randomUUID(),
                        text_annotations: [],
                    },
                },
            },
        }
    }

    getContainerFromOutputStart(
        outputStartContainer: ContainerDataType<
            ContainerType.TextAnnotation,
            TextAnnotationDataType
        >,
        mode: TaskMode
    ) {
        const draftContainer = cloneDeep(outputStartContainer)

        if (draftContainer && !isViewerMode(mode)) {
            draftContainer.data.data.quality_check.evaluation_on_response_version_id = {}
            draftContainer.decision = null
        }

        return draftContainer
    }

    /**
     * While saving/submitting, we update the annotation list with the latest selection ranges.
     * Annotations in each field are grouped by their field path and then sorted by their start index.
     */
    getModifiedDraftOutputContainer = (
        draftOutputContainer: ContainerDataType<
            ContainerType.TextAnnotation,
            TextAnnotationDataType
        >,
        taskConfig: TaskConfigType<ContainerType.TextAnnotation, TextAnnotationDataType>
    ) => {
        const textAnnotationData: TextAnnotationsListType[] = []
        this.containerContext?.task.getAnnotationList().forEach(annotation => {
            const fieldPath = annotation.selection.fieldPath

            let textAnnotationForField = textAnnotationData.find(
                item => item.target.field_path === fieldPath
            )

            if (!textAnnotationForField) {
                textAnnotationData.push({
                    target: {
                        entity_type: 'CONTENT_ENTITY',
                        entity_id:
                            taskConfig.assignment.task.input_container.data.data?.content_entity
                                ?.id ?? '',
                        field_path: fieldPath,
                        entity_source: 'INPUT_CONTAINER',
                    },
                    annotations: [],
                })

                textAnnotationForField = textAnnotationData.find(
                    item => item.target.field_path === fieldPath
                )
            }

            textAnnotationForField!.annotations.push({
                value_type: 'TEXT_ANNOTATION',
                value: {
                    id: annotation.id,
                    start_index: annotation.selection.startIndex,
                    end_index: annotation.selection.endIndex,
                    class_name:
                        this.containerContext?.task
                            .getClasses()
                            .find(classItem => classItem.id === annotation.classId)?.name ?? '',
                    extra_info: {
                        comment_attribute_name: {
                            value: annotation.comment,
                            value_type: 'STRING',
                        },
                    },
                },
            })
        })

        draftOutputContainer.data.data.response.text_annotations = textAnnotationData
        return draftOutputContainer
    }
}
